export class Panel {
    public element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
    }
}